module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }